
import * as React from 'react';
import styled from 'styled-components';
import { Typography } from '@mui/material';

import { getColor} from '@process-advisor/process-miner/shared/theme';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DataGrid } from '@process-advisor/process-miner/time/dataGrid';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { Event } from '@process-advisor/process-miner/api/events';
import { TimeInActivityOptions } from '@process-advisor/process-miner/time/timeInActivityOptions';

type Row = {};

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    background-color: ${getColor('white')};
    padding-top: 10px;
    padding-bottom: 10px;
`;

const Source = styled.div`
  align-items: center;
`;

export const TimeInActivity: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);
    const [columns, setColumns] = React.useState([]);
    const [source, setSource]  = React.useState('');

    React.useEffect(() => {
        updateColumns()

    }, []);

    useApiListener(Event.setActionBar_Time, () => {
        updateColumns()
    });

    useApiListener(Event.updateTimeInActivity, () => {
        updateColumns()
    });

    function applyColor(params) {
        let column = params.column.colId + '_bc'
        if (params.data === undefined) return ''
        let backgroundColor = params.data[column]
        return  {backgroundColor: backgroundColor};
    }

    function updateColumns() {
        setData(apiProvider.getTimeData());
        let initialColumns = apiProvider.getTimeColumns();
        let tempActivityColumns = [] 
        for (let j = 0; j < initialColumns.length; j++) {
            if (initialColumns[j].headername === 'Duration') initialColumns[j].valueFormatter = ({ value }) => apiProvider.formatTime({ duration: value })

            if (initialColumns[j].field.startsWith('^^^') === true) {
                initialColumns[j].field = initialColumns[j].field.replace('^^^','')    
                tempActivityColumns.push(initialColumns[j].field)
                initialColumns[j].cellStyle = params => applyColor(params)
                if (apiProvider.getTimeMetric() === 'count' ) initialColumns[j].valueFormatter = ({ value }) => value
                if (apiProvider.getTimeMetric() === 'duration' || apiProvider.getTimeMetric() === 'time_spent') {
                    initialColumns[j].valueFormatter = ({ value }) => apiProvider.formatTime({ duration: value })
    
                    let vf = []
                    let vtp = {}
                    vtp['valueFormatter'] = ({ value }) => apiProvider.formatTime({ duration: value })
                    vf.push(vtp)
                    initialColumns[j].filterParams = vf
                    
                }
            }
            
        }
        // derive the activity columns
        if (apiProvider.getInitialAALoad() === true) {
            setColumns(initialColumns)
            apiProvider.setInitialAALoad({value: false})
        } else {
            let initialColumns = apiProvider.getTimeColumns();
            let changedColumns = apiProvider.getAAGridState()

            let activityColumn = false
            let tempField = ''
            for (let j = 0; j < initialColumns.length; j++) {
                for (let i = 0; i < changedColumns.length; i++) {
                    activityColumn = false
                    tempField = initialColumns[j].field
                    
                    if (initialColumns[j].field.startsWith('^^^') === true) activityColumn = true
                    if (activityColumn === true) tempField = initialColumns[j].field.replace('^^^','')

                    if (changedColumns[i].colId === 'ag-Grid-AutoColumn') {
                        changedColumns.splice(i,1)
                        i --
                    } else {
                        if (tempField === changedColumns[i].colId) {
                            changedColumns[i].field = tempField
                            changedColumns[i].headername = initialColumns[j].headername
                            changedColumns[i].enableRowGroup = initialColumns[j].enableRowGroup
                            changedColumns[i].suppressColumnsToolPanel = initialColumns[j].suppressColumnsToolPanel
                            changedColumns[j].cellStyle = params => applyColor(params)
                            changedColumns[i].filter = initialColumns[j].filter
                            changedColumns[i].aggFunc = apiProvider.getTimeAggregation()
                            if ((apiProvider.getTimeMetric() === 'count' && activityColumn === true) ) changedColumns[i].valueFormatter = ({ value }) => value
                            if ((apiProvider.getTimeMetric() === 'duration' && activityColumn === true) || initialColumns[j].headername === 'Duration' ) changedColumns[i].valueFormatter = ({ value }) => apiProvider.formatTime({ duration: value })
                        }
                    }
                }
            }
            setColumns(changedColumns)
        }
        setSource(apiProvider.getRCDescription())
    }


    const rows = data.map((row, id) => ({ id, ...row }));
    
    return (
        <Wrapper>
            <TimeInActivityOptions/>
            <Source>
                <Typography
                    variant="caption"
                    align="center"
                    sx={{ paddingLeft: '20px', fontSize: '14px', fontWeight: '600', fontFamily: 'system-ui'
}}
                    component="div">
                    {source}
                </Typography>
            </Source>
            <DataGrid
                rows={rows}
                columns={columns}
                type={'summary'}/>

        </Wrapper>
    );
};
